// Extending from
import Controller from '@ember/controller';
// Ember Imports
import { service } from '@ember/service';

export default class MyProfileController extends Controller {
  // Services
  @service
  session;
}
